export default __webpack_public_path__ + "static/media/ConfiguratorClient.c50da973.png";